<template lang="html">
  <div class="row time-picker">
    <select required v-model="hour" @change="updateTime">
      <option :value="i" v-for="i in 12" :key="i">{{i}}</option>
    </select>
    <select required v-model="minute" @change="updateTime">
      <option :value="i" v-for="i in ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']" :key="i">{{i}}</option>
    </select>
    <select required v-model="meridian" @change="updateTime">
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      hour: 8,
      minute: "00",
      meridian: "AM"
    };
  },
  created() {
    this.setTime();
  },
  methods: {
    setTime() {
      let [hour, minute] = (this.value || "10:00:00").split(":");
      this.minute = minute;
      hour = Number.parseInt(hour);
      if (hour >= 12) {
        this.meridian = "PM";
        hour = (hour % 12).toString();
      } else {
        this.meridian = "AM";
      }
      if (hour == "0") {
        hour = "12";
      }
      this.hour = hour.toString();
      this.updateTime();
    },
    updateTime() {
      let hour;
      if (this.hour == "12" && this.meridian == "AM") {
        hour = "00";
      } else if (this.hour !== "12" && this.meridian == "PM") {
        hour = Number.parseInt(this.hour) + 12;
      } else {
        hour = this.hour;
      }
      this.$emit("input", `${hour}:${this.minute}`);
    }
  },
  watch: {
    value() {
      this.setTime();
    }
  }
};
</script>

